import DatePicker from './src/picker/date-picker';



export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/date-picker2/index.js